<template>
    <el-select
      clearable
      filterable
      remote
      reserve-keyword
      placeholder="请选择客户名称"
      @focus="handleSelectBlur"
      @change="handleSelectChange"
      @clear="handleSelectClear"
      :remote-method="handleCustomSearch"
      :loading="selectData.loading"
      :value="searchCus">
      <el-option
        v-for="(item) in selectList"
        :label="item.name"
        :value="item.uid"
        :key="item.uid">
          <div v-if="[item.name, item.depaName].filter(Boolean).join('-').length > 40">
            <el-tooltip
              class="item custom-select-item"
              effect="dark"
              :content="[item.name, item.depaName].filter(Boolean).join('-')"
              placement="top">
              <span style="float: left" class="select-item-left">{{ [item.name, item.depaName].filter(Boolean).join('-') }}</span>
            </el-tooltip>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.customerNo }}</span>
          </div>
        <div v-else>
          <span style="float: left" class="select-item-left">{{ [item.name, item.depaName].filter(Boolean).join('-') }}</span>
          <span style="float: right; color: #8492a6; font-size: 13px">{{ item.customerNo }}</span>
        </div>
      </el-option>
      <el-option
        v-if="searchCustomerList.totalCount > selectData.pageSize && selectData.pageIndex < searchCustomerList.totalPages"
        label="点击加载更多"
        value="点击加载更多"
        :disabled="true"
        style="cursor:pointer;">
        <span @click="handleMoreCustomList()">点击加载更多</span>
      </el-option>
    </el-select>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    val: {
      type: String,
      default: '',
    },
    customName: String,
  },
  data() {
    return {
      isMore: false,
      selectData: {
        loading: false,
        query: '',
        pageIndex: 1,
        pageSize: 5,
      },
      selectList: [],
    };
  },
  computed: {
    ...mapGetters({
      searchCustomerList: 'clue/searchCustomerList',
    }),
    searchCus() {
      return this.val || this.selectData.query;
    },
  },
  watch: {
    customName(val) {
      this.getCustomSelectList(val);
    },
  },
  methods: {
    ...mapActions({
      searchCustomer: 'clue/searchCustomer',
    }),
    handleSelectBlur() {
      if (this.val) return;
      this.selectData.pageIndex = 1;
      this.selectData.query = '';
      this.getCustomSelectList();
    },
    handleSelectChange(value) {
      this.$emit('change', value);
    },
    handleSelectClear() {
      this.selectData.query = '';
    },
    handleCustomSearch(query) {
      this.selectData.query = query;
      this.selectData.pageIndex = 1;
      this.getCustomSelectList();
    },
    getCustomSelectList(val) {
      this.searchCustomer({
        customerName: val || this.selectData.query,
        pageSize: this.selectData.pageSize,
        pageNumber: this.selectData.pageIndex,
      }).then(() => {
        if (this.selectData.pageIndex === 1) {
          this.selectList = [];
        }

        if (this.searchCustomerList.results) {
          this.searchCustomerList.results.forEach((item) => {
            this.selectList.push(item);
          });
        }
      });
    },
    handleMoreCustomList() {
      this.isMore = true;
      this.selectData.pageIndex += 1;
      this.getCustomSelectList();
    },
  },
};
</script>
